import { observable, action, computed } from 'mobx'
import Parse from 'parse'
import _ from 'lodash'
import UserStore from './UserStore'
import BookingStore from './BookingStore'
import directus from '../utils/directus'

const PRELOAD_WEEKS = 1

class GolfCourseStore {

    @observable golfCourses
    @observable golfCoursesBookings
    @observable bookingLoadingLimitation
    @observable loadedAfter
    @observable golfCoursesCount
    @observable leadingGolfCoursesCount

    constructor() {
        this.golfCoursesBookings = []
        this.golfCourses = null
        this.golfCoursesCount = 0
        this.leadingGolfCoursesCount = 0

        const from = new Date()
        from.setDate( from.getDate() + 1 )
        from.setDate( from.getDate() - PRELOAD_WEEKS * 7 - ( from.getDay() - 2 ) % 7 )
        from.setHours(0,0,0,0)
        this.loadedAfter = from
        this.bookingLoadingLimitation = from
    }

    @computed get isGolfCourses() {
        return this.golfCourses && this.golfCourses.length > 0 && this.golfCourses[0].objectId ? true : false
    }

    @computed get isGolfCourseData() {
        if (this.isGolfCourses) {
            return this.golfCoursesBookings.length >= this.golfCourses.length ? true : false
        } else {
            return false
        }
    }

    @action setGolfCourses = (golfCourses) => {
        this.golfCourses = golfCourses
        this.golfCoursesCount = golfCourses.length
        this.leadingGolfCoursesCount = golfCourses.filter(item => item.isLeading).length
    }

    @action checkBookingLimitation = ( bookingStoreGolfCourse ) => {
      if(!this.bookingLoadingLimitation) return
      this.bookingLoadingLimitation = null
      this.getAllBookings( bookingStoreGolfCourse )
    }

    @action pushGolfCourseBookings = (golfCourseBookingObj) => {
        this.golfCoursesBookings.push(golfCourseBookingObj)
    }

    @action updateGolfCourseBooking = (golfCourseBookingObj) => {
        const item = this.golfCoursesBookings.find( item => item.courseName === golfCourseBookingObj.courseName)
        if(!item) this.pushGolfCourseBookings(golfCourseBookingObj)
        else item.bookingsPerDate = golfCourseBookingObj.bookingsPerDate
        // this.golfCoursesBookings.push(golfCourseBookingObj)
    }

    @action sortGolfCoursesBookings = () => {
        if (this.isGolfCourseData) {
            this.golfCoursesBookings = _.sortBy(this.golfCoursesBookings, function(bookingsObject) {
                return bookingsObject.golfCourse.orderNumber;
            });
        }
    }

    getGolfCourses() {
      this.golfCourses = null

      let golfCourses = []
      let golfCourseQuery = new Parse.Query("GolfCourse")
      golfCourseQuery.include('hotel');
      golfCourseQuery.include('region');

      const filters = ['qZ6C5jN6zW', 'DHMSCVubDl', 'zw1ZJ1wVqn', 'nSt3gsef85', '46OsYGNyJ7']

      golfCourseQuery.each(async golfCourse => {
        if (golfCourse.toJSON().isActive === true) {

          // const hotelQuery = new Parse.Query("Hotels")
          //
          // let hotels = []
          //
          // await hotelQuery.equalTo("golfCourse", golfCourse).each(hotel => hotels.push(hotel.toJSON()))
          //   .then(() => {
          //     let data = golfCourse.toJSON()
          //     golfCourses.push(data)
          //     data.hotels = hotels
          //   }).catch(err => console.error(err))
            let data = golfCourse.toJSON()
            console.log(data);

            // if(filters.includes(data.objectId))
              golfCourses.push(data)

        }
      }).then(res => {
        console.log(golfCourses);
          this.setGolfCourses(golfCourses)
      }).then(res => {
          this.getAllBookings()
      }).catch(error => {
          console.error("error", error)
      })
    }

    getAllBookings( bookingStoreGolfCourse ) {

        if(UserStore.me == null) return

        // this.golfCoursesBookings = []
        // this.golfCourses.forEach(golfCourse => {
        //     this.getBookings(golfCourse.objectId)
        // })

        console.log(this.bookingLoadingLimitation);
        const limit = this.bookingLoadingLimitation || new Date("1.1.2000")
        let golfcourses = this.golfCourses.map(item => item.objectId)


        Parse.Cloud.run('getAllBookings', {
          from: this.bookingLoadingLimitation || null,
          golfcourses
        })
        .then(res => {
          console.log(res);
          // this.golfCoursesBookings = []
          for( const item of res ) {
            this.updateGolfCourseBooking( item )
          }
          this.sortGolfCoursesBookings()

          this.loadedAfter = limit

          if(bookingStoreGolfCourse) {
            const entry = res.find( item => bookingStoreGolfCourse === item.golfCourse.objectId )
            console.log(entry);
            console.log(entry.bookingsPerDate);

            BookingStore.setBookingsPerDate(entry.bookingsPerDate)
          }
        })
        .catch(error => {
            console.error("error", error)
        })
    }

    // async getBookings(golfCourseId) {
    //     const from = new Date()
    //     from.setDate( from.getDate() + 1 )
    //     from.setDate( from.getDate() - PRELOAD_WEEKS * 7 - ( from.getDay() - 1 ) % 7 )
    //     from.setHours(0,0,0,0)
    //
    //     Parse.Cloud.run('getBookings', {
    //           from,
    //         })
    //         .then(bookingsData => {
    //             this.pushGolfCourseBookings(bookingsData)
    //             this.sortGolfCoursesBookings()
    //         })
    //         .catch(error => {
    //             console.error("error", error)
    //         })
    // }
}

const store = new GolfCourseStore()
export default store



// WEBPACK FOOTER //
// /src/stores/GolfCourseStore.js